import React, {useContext, useEffect} from "react";
import {RecordsManagementContext, ViewMangementContext} from "./StatesMangement/InitialiseContext";
import {
    Elink,
    FetchEstimateDefaultRoomRecordsUrl,
    FetchEstimateDetailRecordsUrl,Subdomain
} from "./CommonComponents/Routes";
import PageNotFound from "./CommonComponents/PageNotFound";
import Loader from "./CommonComponents/Loader";
import SomethingWentWrong from "./CommonComponents/SomethingWentWrong";
import axios from "axios";
import MobileLinkStart from "./MobileLink/MobileLinkStart";
import MobileLinkBedrooms from "./MobileLink/MobileLinkBedrooms";
import MobileLinkDefaultRooms from "./MobileLink/MobileLinkDefaultRooms";
import MobileLinkMyRooms from "./MobileLink/MobileLinkMyRooms";
import RoomDetail from "./MobileLink/RoomDetail";
import AddNewRoom from "./MobileLink/AddNewRoom";
import ReviewAndSubmitPage from "./MobileLink/ReviewAndSubmitPage";
import CustomRoom from "./MobileLink/CustomRoom";
import AddInventories from "./MobileLink/AddInventories";
import CustomItemPage from "./MobileLink/CustomItemPage";
import SubmitInventory from "./MobileLink/SubmitInventory";
import TakePicture from "./MobileLink/TakePicture";

const MobileLinkPage = () => { // This component render the diff pages.
    let PageView = useContext(ViewMangementContext)
    let RecordsController = useContext(RecordsManagementContext)
    let LastVisitedPage, DefaultRoomId
    useEffect(async () => {
        if (Elink === null) { // If params 'elink' is not present in url then Page-Not-Found render in screen.
            PageView.Set('PAGE_NOT_FOUND')
        } else {
            await Subdomain();
            await axios({
                method: 'post',
                url: FetchEstimateDetailRecordsUrl,
                params: {estimate_key: Elink}
            }).then((response) => {
                RecordsController.SetCP_PageDetails(response.data);
                RecordsController.SetML_Start(response.data);
                RecordsController.setOtherBedrooms(response.data.BedroomCount)
                LastVisitedPage = response.data.LastPageVisited
                DefaultRoomId  = response.data.DefaultRoomsId[0]
            });
            if (LastVisitedPage === null){
                PageView.Set("SHOW_MOBILE_LINK")
            }
            else{
                if(DefaultRoomId && LastVisitedPage === 'SHOW_MOBILE_LINK_DEFAULT_ROOMS') {//post request is send to "fetch default_rooms and inventories" to fetch the inventory record of the estimate
                    axios({
                        method: 'post',
                        url: FetchEstimateDefaultRoomRecordsUrl,
                        params: {estimate_key: Elink, default_room_id: DefaultRoomId}
                    }).then(async (response) => {
                        await RecordsController.SetDefaultRoomHash(response.data);
                    });
                }
                PageView.Set(LastVisitedPage)
            }
        }
    }, [])

    if (PageView.For === 'LOADING') {
        return (<Loader/>);
    }
    else if (PageView.For === 'PAGE_NOT_FOUND') {
        return (<PageNotFound/>);
    }
    else if (PageView.For === 'SOMETHING_WENT_WRONG') {
        return (<SomethingWentWrong/>);
    }
    else if (PageView.For === 'SHOW_MOBILE_LINK'){
        return (<MobileLinkStart/>);
    }
    else if (PageView.For === 'SHOW_MOBILE_LINK_BEDROOM'){
        return (<MobileLinkBedrooms/>);
    }
    else if (PageView.For === 'SHOW_MOBILE_LINK_DEFAULT_ROOMS'){
        return (<MobileLinkDefaultRooms/>);
    }
    else if (PageView.For === 'SHOW_MOBILE_LINK_MY_ROOMS'){
        return (<MobileLinkMyRooms/>);
    }
    else if (PageView.For === 'MOBILE_ROOM_DETAIL'){
        return (<RoomDetail/>);
    }
    else if (PageView.For === 'ADD_NEWROOM'){
        return (<AddNewRoom/>);
    }
    else if (PageView.For === 'REVIEW_AND_SUBMIT'){
        return (<ReviewAndSubmitPage/>);
    }
    else if (PageView.For === 'CUSTOM_ROOM'){
        return (<CustomRoom/>);
    }
    else if (PageView.For === 'ADD_INVENTORIES'){
        return (<AddInventories/>);
    }
    else if (PageView.For === 'CUSTOM_ITEM_PAGE'){
        return (<CustomItemPage/>);
    }
    else if (PageView.For === 'SUBMIT_INVENTORY'){
        return (<SubmitInventory/>);
    }
    else if (PageView.For === 'TAKE_PICTURE'){
        return (<TakePicture/>);
    }
    else {
        return (<PageNotFound/>);
    }
}

export default MobileLinkPage;